import React, { useEffect, useState } from "react";
import { Empty, Pagination } from "antd";
import JobPostFilterMenu from "./JobPostFilterMenu";
import JobPostCard from "./JobPostCard";
import { useJobPosts } from "../../../Hooks/useJobPosts";
import { findAllJobPostDto } from "../../../Interface/Index";
import { JobApplication } from "../../../Entities/job-application.entity";

interface AllOpeningsProps {
  jobApplications: JobApplication[];
}

const AllOpenings: React.FC<AllOpeningsProps> = ({ jobApplications }) => {
  const [filters, setFilters] = useState<findAllJobPostDto>({
    page: 1,
    limit: 9,
    position: [],
    searchQuery: null,
  });
  const [isNoActivejobPosts, setIsNoActiveJobPosts] = useState<boolean>(false);

  const { jobPosts, pageData, positionWithOpeningCount, isFetched } =
    useJobPosts(filters);

  const handlePageChange = (page: number) => {
    setFilters({ ...filters, page });
  };

  useEffect(() => {
    if (
      isFetched &&
      jobPosts.length === 0 &&
      filters.position.length === 0 &&
      filters.searchQuery === null
    ) {
      setIsNoActiveJobPosts(true);
    }
  }, [isFetched, jobPosts, filters]);

  const renderJobPosts = () => {
    return jobPosts.length > 0 ? (
      <div className="job-listing__grid">
        {jobPosts.map((jobPost) => {
          const isApplied = jobApplications.some(
            (application) => application.jobPost._id === jobPost._id,
          );

          return (
            <JobPostCard
              key={jobPost._id}
              _id={jobPost._id}
              title={jobPost.title}
              position={jobPost.position}
              description={jobPost.description}
              slug={jobPost.slug}
              isApplied={isApplied}
              isActive={jobPost.isActive}
            />
          );
        })}
      </div>
    ) : (
      <div className="job-listing__no-results">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No Job Posts found"
        />
      </div>
    );
  };

  return (
    <div className="job-listing__card-body">
      {!isNoActivejobPosts && isFetched && (
        <JobPostFilterMenu
          filters={filters}
          setFilters={setFilters}
          positionWithOpeningCount={positionWithOpeningCount}
        />
      )}

      {!isNoActivejobPosts && isFetched && renderJobPosts()}

      {isNoActivejobPosts && isFetched && (
        <div className="job-listing__no-results">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No Data"
          />
        </div>
      )}

      {!isNoActivejobPosts && isFetched && pageData.totalPages > 1 && (
        <div className="job-listing__pagination">
          <Pagination
            current={filters.page || 1}
            total={pageData.total}
            pageSize={filters.limit || 10}
            onChange={handlePageChange}
            showSizeChanger={false}
            className="job-listing__pagination-antd"
          />
        </div>
      )}
    </div>
  );
};

export default AllOpenings;
